export const SWIPER_YEAR_IMG = [
  require('../assets/year/slide1.png'),
  require('../assets/year/slide2.png'),
  require('../assets/year/slide3.png'),
  require('../assets/year/slide4.png'),
  require('../assets/year/slide5.png'),
  require('../assets/year/slide6.png'),
  require('../assets/year/slide7.png'),
  require('../assets/year/slide8.png')
]

export const SWIPER_TREA_IMG = [
  require('../assets/trea/slide1.png'),
  require('../assets/trea/slide2.png'),
  require('../assets/trea/slide3.png'),
  require('../assets/trea/slide4.png')
]

export const CONTRACTS = {
  facebook: "https://www.messenger.com/t/105658637584827",
  telegram: "https://t.me/CSKH888b"
}

export const FORM_VALID_MESSAGE = {
  loginFailTitle: "ĐĂNG NHẬP THẤT BẠI",
  registerFailTitle: "ĐĂNG KÝ THẤT BẠI",
  emptyMsg: "* Vui lòng điền đầy đủ thông tin.",
  usernameFormatErr: "* Tên đăng nhập phải từ 4 đến 20 kí tự.",
  passwordMsg: "* Mật khẩu phải từ 6 đến 15 kí tự.",
  phoneInvalid: "Định dạng phone chưa chính xác",
  emailInvalid: "Email không đúng định dạng.",
  emailFormatErr: "* Chỉ chấp nhận email @gmail.com ,@yahoo.com .",
  loggedTitle: "ĐĂNG NHẬP THÀNH CÔNG",
  loggedMsg: "Tự động đăng nhập trong 5s",
  registerTitle: "ĐĂNG KÝ THÀNH CÔNG",
  registerMsg: "Tự động đăng nhập trong 5s",
  wrongMsg: "Thông tin bạn điền chưa chính xác"
}

export const DOMAIN_INVITE_CODE = {
  "tanthu.banca2q.club":"qkah2",
  "noto.banca2q.club":"qkah2",
  "hailoc.banca2q.club":"qkah2",
  "giaitri.go2q.club":"dn2q1",
  "doithuong.go2q.club":"dn2q1",
  "km.go2q.club":"dn2q1",
  "vip.nohu2q.life":"jndcu",
  "vebo.nohu2q.life":"jndcu",
  "l0cla.nohu2q.life":"jndcu",
  "hot.sport2q.life":"dsy5f",
  "dk.sport2q.life":"dsy5f",
  "mienphi.sport2q.life":"dsy5f",
  "nhanloc.thethao2q.life":"b1777",
  "vip.thethao2q.life":"b1777",
  "tanthu.thethao2q.life":"b1777",
}

export const DOMAIN_AGENT_LINE = {
  "ads25.win888b.com": 'vnc_ba25',
  "ads26.win888b.com": 'vnc_ba26',
  "ads27.win888b.com": 'vnc_ba27',
  "ads28.win888b.com": 'vnc_ba28'
}


export const DOMAIN_GOOGLE_GTAG = {
  "hot.mayman888.vip": "G-3829W77MZC",
  "loc.km8888b.com": "G-XS6WDBXR3N",
  "bongda888b.com": "G-QEC2N4SSJS",
  "vip.8886688.vip": "UA-242791887-1",
  "km.anto8866.vip": "G-5872SLTPWS",
  "ads02.win888b.com": "G-9EGDS5806F",
  "ads03.win888b.com": "G-V22K65LVEY"
}

export const PHONES_PREFIX_REPLACE = {
  "0162":	"032",
  "0163":	"033",
  "0164":	"034",
  "0165":	"035",
  "0166":	"036",
  "0167":	"037",
  "0168":	"038",
  "0169":	"039",
  "0120":	"070",
  "0121":	"079",
  "0122":	"072",
  "0126":	"076",
  "0128":	"078",
  "0123":	"083",
  "0124":	"084",
  "0125":	"085",
  "0127":	"081",
  "0129":	"082",
  "0182":	"052",
  "0186":	"056",
  "0188":	"058",
  "0199":	"059"
}

export const PHONES_PREFIX_FORE = ['0162','0163','0164','0165','0166','0167','0168','0169','0120','0121','0122','0126','0128','0123','0124','0125','0127','0129','0182','0186','0188','0199']

export const PHONES_PREFIX_THREE = ['086','096','097','098','032','033','034','035','036','037','038','039','070','079','072','076','078','089','090','093','077','088','091','094','083','084','085','081','082','092','052','056','058','019','059','099','095','043','087']



// WEBPACK FOOTER //
// ./src/utils/constant.js